import React from 'react';

import {
  CanCreateOfflinePo,
  CreateInvoicePermission,
  CreatePoPermission,
} from 'src/components/guards/PermissionsList';
import usePermission from 'src/hooks/usePermissions';
import CreatePo from '../enter_receipt/enter_receipt_wizard/CreatePo';
import { permissionMessage } from '../enter_receipt/enter_receipt_wizard/CreateReceiptWithoutPoWizard';
import CreateReceiptWithInvoice from './enter_invoice_wizard/CreateReceiptWithInvoice';
import RequirePermissionWizard from './enter_invoice_wizard/RequirePermissionWizard';

interface IProps {
  openModal: boolean;
  closeModal: () => void;
}

const CreatePoWithReceipt: React.FC<IProps> = ({ openModal, closeModal }) => {
  const hasPermissionToCreatePO = usePermission({ permissions: CanCreateOfflinePo });
  const hasPermissionToRequirePO = usePermission({ permissions: CreatePoPermission });
  const hasPermissionToCreateInvoice = usePermission({
    permissions: CreateInvoicePermission,
    or: true,
  });

  let defaultRendering: React.ReactElement<any> | null = null;
  if (!hasPermissionToCreatePO || (!hasPermissionToRequirePO && !hasPermissionToCreateInvoice)) {
    defaultRendering = (
      <RequirePermissionWizard
        title={'Cannot Create PO'}
        openModal={openModal}
        closeModal={closeModal}
        content={permissionMessage(true)}
      />
    );
  } else if (hasPermissionToRequirePO) {
    defaultRendering = <CreatePo openModal={openModal} closeModal={closeModal} />;
  } else if (hasPermissionToCreateInvoice) {
    defaultRendering = <CreateReceiptWithInvoice openModal={openModal} closeModal={closeModal} />;
  }

  return defaultRendering;
};

export default CreatePoWithReceipt;
